import RemoveDeviceModal from './RemoveDeviceModal';

export default RemoveDeviceModal;
